import ComponentName from 'constant/ComponentName';
import NavigationUtil from './NavigationUtil';
import VariableType from 'constant/VariableType';
import { ListType } from '../constant/Constants';
import { store } from '../redux/store';

class ComponentUtil {
  public static handleLink(component: ComponentName, title: string, payload: any) {
    const baseUrl = window.location.origin + '/' + NavigationUtil.getTenant();
    switch (component) {
      case ComponentName.ADMIN_USER:
        return `${baseUrl}/admin/user`;
      case ComponentName.ADMIN_GROUP:
        return `${baseUrl}/admin/group`;
      case ComponentName.ADMIN_ROLE:
        return `${baseUrl}/admin/role`;
      case ComponentName.TRANSACTION:
        return this.makeUrl(`transaction/edit/${title}`);
      case ComponentName.ENRICHMENT:
      case ComponentName.BASIC_VARIABLE:
      case ComponentName.API_VARIABLE:
      case ComponentName.QUERY_VARIABLE:
      case ComponentName.VELOCITY:
      case ComponentName.LIST_VARIABLE: {
        const { type, name } = payload;
        const route = this.getEnrichmentRoute(type);
        return this.makeUrl(`enrichment/${route}/${name}`);
      }
      case ComponentName.STRUCT:
        return this.makeUrl(`struct/edit/${title}`);
      case ComponentName.CONNECTION:
        return this.makeUrl(`connection/edit/${title}`);
      case ComponentName.LIST:
      case ComponentName.LIST_DATA: {
        const { type, name } = payload ?? {};
        const resolvedName = name ?? title;
        let typePath = (type as ListType) === 'INTERNAL_LIST' ? 'file' : 'query';
        return this.makeUrl(`list/${typePath}/edit/${resolvedName}`);
      }
      case ComponentName.STREAM:
        return this.makeUrl(`stream/edit/${title}`);
      case ComponentName.RULE:
        return this.makeUrl(`rule/edit/${title}`);
      case ComponentName.CONFIGURATION:
        return this.makeUrl(`configuration/edit/${title}`);
      case ComponentName.ACTION: {
        const { template } = payload;
        return this.makeUrl(`action/${template}/${title}`);
      }
      case ComponentName.AI_MODEL:
        return this.makeUrl(`ai-model/edit/${title}`);
      case ComponentName.TRACKER:
        return this.makeUrl(`tracker/edit/${title}`);
    }
  }

  private static makeUrl(url: string) {
    const baseUrl = window.location.origin + '/' + NavigationUtil.getTenant();
    return `${baseUrl}/${url}`;
  }

  private static getEnrichmentRoute(enrichmentType: VariableType): string | undefined {
    switch (enrichmentType) {
      case VariableType.QUERY:
        return 'query';
      case VariableType.BASIC:
        return 'basic';
      case VariableType.LIST:
        return 'list';
      case VariableType.API:
        return 'api';
      case VariableType.VELOCITY:
        return 'velocity';
      default:
        return undefined;
    }
  }

  public static isLocked(componentName: ComponentName, id: string) {
    const { globalWorkers: locks } = store.getState().component;
    if (locks[componentName] == undefined) {
      return false;
    }
    return locks[componentName].find((l) => l.componentId == id) != undefined;
  }
}

export default ComponentUtil;
